// Calendar arithmetic is in the club zone, never milliseconds across DST days.
export function messageDay(value, timeZone) {
  if (!value) return null
  const date = new Date(value)
  if (!Number.isFinite(date.getTime())) return null
  return new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(date)
}

export function chatDateLabel(value, { locale, timeZone, t, now = new Date() }) {
  const day = messageDay(value, timeZone)
  if (!day) return ''
  const today = messageDay(now, timeZone)
  if (day === today) return t('memberFrontDesk.today')
  const parts = new Intl.DateTimeFormat('en', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now)
  const get = type => Number(parts.find(part => part.type === type).value)
  const yesterday = new Date(Date.UTC(get('year'), get('month') - 1, get('day') - 1, 12))
  if (day === messageDay(yesterday, 'UTC')) return t('memberFrontDesk.yesterday')
  return new Intl.DateTimeFormat(locale, { timeZone, day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(value))
}

export function mergeChatMessages(...pages) {
  const byId = new Map()
  pages.flat().forEach(message => byId.set(message.id, message))
  return [...byId.values()].sort((a, b) => {
    // Unconfirmed sends stay at the end and never introduce a guessed day.
    if (Boolean(a.optimistic) !== Boolean(b.optimistic)) return a.optimistic ? 1 : -1
    const left = a.created_at ? Date.parse(a.created_at) : NaN
    const right = b.created_at ? Date.parse(b.created_at) : NaN
    if (!Number.isFinite(left) && !Number.isFinite(right)) return 0
    if (!Number.isFinite(left)) return 1
    if (!Number.isFinite(right)) return -1
    return left - right || String(a.id).localeCompare(String(b.id), 'en')
  })
}
